(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-country-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'lumaCountryPopupDismissed';
        /* remove the temporary cache-busting parameter from the address bar */
    try {
      if (/[?&]lc=\d+/.test(window.location.search)) {
        var cleanSearch = window.location.search.replace(/([?&])lc=\d+&?/, '$1').replace(/[?&]$/, '');
        window.history.replaceState(window.history.state, '', window.location.pathname + cleanSearch + window.location.hash);
      }
    } catch (e) {}

    document.querySelectorAll('.country-welcome-popup').forEach(function (popup) {
      var freq = popup.dataset.frequency;
      var store = freq === 'forever' ? window.localStorage : window.sessionStorage;

      function remember() {
        // "always" (design preview) never remembers, so it re-shows every load on purpose.
        if (freq !== 'always') {
          store.setItem(STORAGE_KEY, '1');
        }
      }

      function dismiss() {
        popup.setAttribute('hidden', '');
        document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
        remember();
      }

      var closeButton = popup.querySelector('.country-welcome-popup__close');
      if (closeButton) {
        closeButton.addEventListener('click', dismiss);
      }

      var form = popup.querySelector('.country-welcome-popup__form');
      var input = popup.querySelector('input[name="country_code"]');
      var isSubmitting = false;

      // If the shopper navigates Back to this page after picking a country,
      // the browser often restores it from the back/forward cache instead of
      // reloading it — which brings back this exact JS state (isSubmitting
      // still true, button still stuck showing "loading") from the moment
      // they clicked. Without this, every click after Back is silently
      // ignored until a manual page reload resets the script.
      window.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        isSubmitting = false;
        if (form) form.classList.remove('is-submitting');
        popup.querySelectorAll('.country-welcome-popup__link.is-loading').forEach(function (loadingLink) {
          loadingLink.classList.remove('is-loading');
        });
        var staleNotice = popup.querySelector('.country-welcome-popup__error');
        if (staleNotice) staleNotice.remove();
        if (window.history.state && window.history.state.lumaCountryPopupEntry) {
  popup.removeAttribute('hidden');
  document.body.classList.add('overflow-hidden-mobile', 'overflow-hidden-tablet');
}
      });
function setPopupEntryMarker(on) {
  try {
    var current = window.history.state;
    var state = current && typeof current === 'object' ? Object.assign({}, current) : {};
    if (on) {
      state.lumaCountryPopupEntry = true;
    } else {
      delete state.lumaCountryPopupEntry;
    }
    window.history.replaceState(state, '');
  } catch (e) {}
}
      popup.querySelectorAll('.country-welcome-popup__link').forEach(function (link) {
        link.addEventListener('click', function () {
          if (isSubmitting) return;
          isSubmitting = true;

          link.classList.add('is-loading');
          if (form) form.classList.add('is-submitting');

          remember();

          setPopupEntryMarker(true);
          try { window.sessionStorage.setItem('lumaCountryPickedAt', String(Date.now())); } catch (e) {}
          // Safety net: if the page hasn't navigated away within 6s (blocked
          // request, network issue, etc.), stop showing a stuck loading
          // state and let the shopper try again instead of being trapped.
          var stallTimer = window.setTimeout(function () {
            setPopupEntryMarker(false);
            isSubmitting = false;
            link.classList.remove('is-loading');
            if (form) form.classList.remove('is-submitting');

            var existingNotice = popup.querySelector('.country-welcome-popup__error');
            if (!existingNotice) {
              var notice = document.createElement('p');
              notice.className = 'country-welcome-popup__error';
              notice.textContent = 'Something went wrong — please try again.';
              if (form) form.insertBefore(notice, form.firstChild);
            }
          }, 6000);

          window.addEventListener('pagehide', function () {
            window.clearTimeout(stallTimer);
          });

          if (input && form) {
            input.value = link.dataset.value;
            var backTo = form.querySelector('input[name="return_to"]');
if (backTo) backTo.value = '/?lc=' + Date.now();
            form.submit();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
